<template>
    <v-container>
        <div class="mt-5" v-for="(skill, i) in skills" :key="i">
            <v-card class="d-flex justify-space-between" color="blue-grey lighten-2">
                <v-card class="row ma-1">
                    <v-card-text>
                        <div class="font-italic title black--text pt-2">{{skill.designation}}</div>
                    </v-card-text>
                </v-card>
                <v-card class="row ma-1">
                    <v-card-text>
                        <div class="subtitle-1 pt-2">
                            <v-card-actions>
                                <a :href="skill.company" class="font-italic black--text" target="_blank" rel="noopener noreferrer">{{skill.company}}</a>
                            </v-card-actions>
                        </div>
                    </v-card-text>
                </v-card>
                <v-card class="row ma-1">
                    <v-card-text>
                        <div class="font-italic subtitle-1 black--text pt-2">{{ skill.duration }}</div>
                    </v-card-text>
                </v-card>
                <v-card class="row ma-1">
                    <v-card-text>
                        <div class="subtitle-1 pt-2">
                            <v-card-actions>
                                <a class="font-italic ml-2 black--text" v-for="project in skill.projects" :key="project.url" :href="project.url" target="_blank">
                                    {{project.title + ","}} 
                                </a> 
                            </v-card-actions>
                        </div>
                    </v-card-text>
                </v-card>
            </v-card>
            </div>
    </v-container>
</template>
<script>
  export default {
    data: () => ({
      colors: ['deep-purple', 'deep-purple', 'deep-purple', 'deep-purple', 'deep-purple'],
      skills:[
          {designation: 'Senior Web Application Developer', company: 'https://shadhinbd.com/', duration: '02/2019-present', projects: [
                { url:'https://play.google.com/store/apps/details?id=com.shadhinbd.investee', title:'investee app'},
                { url:'https://play.google.com/store/apps/details?id=com.shadhinbd.investor', title:'investor app'},
                { url:'http://admindd.clementinedatabd.com/', title: 'datadash'}
              ]
          }, 
          {designation: 'Software Engineer', company: 'https://www.ctmt-ltd.com/', duration: '04/2018-02/2019', projects: [
                {url:'https://mail.xcoder.io', title:'email marketing'}, 
                {url:'​https://easyebilling.com/', title:'billing solution'},
                {url:'​https://short.xcoder.io/', title:'url shortening'}
              ]
          }, 
          {designation: 'Software Engineer', company: 'https://gurukulictdl.com.bd/', duration: '09/2017-03/2018', projects: [
                {url:'http://erp.gurukul.edu.bd/', title:'education erp'},
                {url:'http://www.dainikshiksha.com​', title:'dainikshiksha news portal'},
                {url:'http://people.sufifaruq.com/user/login​', title:'vote canvas'}
              ]
          }, 
          {designation: 'Software Engineer', company: 'https://www.tmss-ict.com/', duration: '01/2016-08/2017', projects: [
                {url:'https://imikrof.com/#/', title:'islamic micro finance'},
                {url:'http://mikrof.com/#/', title:'tmss micro-finance'}
              ]
          }, 
      ]
    }),
    methods: {
      genColor (i) {
        return this.colors[i]
      },
    },
  }
</script>